import { apiClient } from '@/shared/services/client'
import type {
  PaginatedCotizaciones,
  AdminStats,
  Cotizacion,
  CotizacionFilters,
  EditarCotizacionPayload,
  MarcarAtendidaPayload,
  SolicitarCotizacionPayload,
} from '../types'

const BASE = '/pricing'

function buildParams(filters: object): string {
  const params = new URLSearchParams()
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') params.append(key, String(value))
  })
  return params.toString()
}

// Admin - Listado paginado
export async function getCotizaciones(filters: CotizacionFilters = {}): Promise<PaginatedCotizaciones> {
  const { data } = await apiClient.get<PaginatedCotizaciones>(`${BASE}/admin/?${buildParams(filters)}`)
  return data
}

// Admin - Estadísticas
export async function getStats(filters: Omit<CotizacionFilters, 'page' | 'page_size' | 'search'> = {}): Promise<AdminStats> {
  const { data } = await apiClient.get<AdminStats>(`${BASE}/admin/stats/?${buildParams(filters)}`)
  return data
}

// Admin - Detalle cotización
export async function getCotizacion(id: number): Promise<Cotizacion> {
  const { data } = await apiClient.get<Cotizacion>(`${BASE}/admin/${id}/`)
  return data
}

// Admin - Editar cotización (parcial)
export async function editarCotizacion(id: number, payload: EditarCotizacionPayload): Promise<Cotizacion> {
  const { data } = await apiClient.patch<Cotizacion>(`${BASE}/admin/${id}/`, payload)
  return data
}

// Admin - Marcar atendida
export async function marcarAtendida(id: number, payload: MarcarAtendidaPayload): Promise<{ message: string; success: boolean }> {
  const { data } = await apiClient.patch(`${BASE}/admin/${id}/atendida/`, payload)
  return data
}

// Admin - Exportar Excel
export async function exportarExcel(filters: Omit<CotizacionFilters, 'page' | 'page_size' | 'search'> = {}): Promise<void> {
  const response = await apiClient.get(`${BASE}/admin/exportar/?${buildParams(filters)}`, {
    responseType: 'blob',
  })
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  const filename = response.headers['content-disposition']
    ?.split('filename="')[1]?.replace('"', '')
    || `cotizaciones_${new Date().toISOString().slice(0, 10)}.xlsx`
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

// Admin - Laboratorios para filtros
export async function getLaboratorios(): Promise<string[]> {
  const { data } = await apiClient.get<string[]>(`${BASE}/admin/laboratorios/`)
  return data
}

// --- Público ---

// Solicitar cotización (público, no requiere auth)
export async function solicitarCotizacion(payload: SolicitarCotizacionPayload): Promise<{ message: string; success: boolean }> {
  const { data } = await apiClient.post(`${BASE}/solicitar/`, payload)
  return data
}
